/* eslint-disable no-console */
import pathToRegex from 'path-to-regexp';
import PathSegment from './PathSegment';
const removeEmptyParams = function () {
  let obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.entries(obj).reduce((acc, _ref) => {
    let [key, value] = _ref;
    return {
      ...acc,
      ...(value === undefined || value === null || value === '' || value === 'undefined' ? {} : {
        [key]: value
      })
    };
  }, {});
};
export default class Path {
  constructor(pathname, query) {
    this.query = query;
    this.pathname = pathname;
    this.segments = this.pathname ? this.pathname.split('/').filter(Boolean) : [];
  }
  async build() {
    const result = await this.segments.reverse().reduce(async (_acc, segment) => {
      const acc = await _acc;
      const pathSegment = new PathSegment({
        segment,
        query: acc.query,
        pathname: acc.pathname
      });
      const {
        query,
        pathname
      } = await pathSegment.process();
      acc.query = query;
      acc.pathname = pathname;
      return acc;
    }, Promise.resolve({
      query: this.query,
      pathname: this.pathname
    }));
    this.query = removeEmptyParams(result.query);
    this.pathname = result.pathname;
  }
  getPathname() {
    if (this.pathname !== '/') {
      // remove any trailing slash if it exists
      this.pathname = this.pathname.replace(/\/$/, '');
      // remove any multiple slashes that remain from path updaters
      this.pathname = this.pathname.replace(/\/\/+/g, '/');
    }

    // create path compiler
    const pathCompiler = pathToRegex.compile(this.pathname);
    const query = removeEmptyParams(this.query);

    // set encode option to not encode url segment parameters
    this.pathname = pathCompiler(query, {
      encode: x => x
    });

    // ensure that the pathname is decoded
    // path-to-regexp 1.7+ doesn't support encode option
    // if we can ensure we are using path-to-regexp 3+ then this is unnecessary
    return decodeURIComponent(this.pathname);
  }
  getQuery() {
    return this.query;
  }
}